import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';

export const PaymentBlockLoader = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width:79.3rem;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    margin:${props.theme.spacing.xlarge} 0 0 0;
  
  `,
);

export const ArrowDownWrap = styled.div(
  props => `
    display:flex;
    justify-content:center;
    align-items:center;
    background:${props.theme.colors.goBrandBlue.light};
    border-radius:50%;
    height:2.6rem;
    width:2.6rem;
  `,
);

export const ArrowDown = styled(ArrowDownIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:#898b91;
    `,
);

export const HeaderWithIconWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content: space-between;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.custom(30)};
  `,
);

export const PaymentBlockHeader = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:2.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);
